<template>
  <div class="flex-col justify-content-center h-100 m-xxl gap-y-lg">
    <AlertIcon class="icon-size-xxl fill-primary"></AlertIcon>
    <p class="color-primary text-center">Sorry, we hebben geen {{ resultType.title }} gevonden.</p>
  </div>
</template>

<script>
export default {
  name: "NothingFound.vue",
  props: {
    resultType: {
      title: {
        type: String,
        required: true,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>